import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { TextButton } from '@bibliocommons/base-buttons';
import { Search as SearchIcon, Cross as CrossIcon } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import './NewSearchButton.scss';

const renderExpanded = () => (
  <div>
    <CrossIcon />
    <ScreenReaderMessage>
      <FormattedMessage id="close_search_form" />
    </ScreenReaderMessage>
  </div>
);

const renderCollapsed = () => (
  <div><SearchIcon /> <FormattedMessage id="new_search" /></div>
);

export default class NewSearchButton extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleClick');
  }

  handleClick() {
    const { expanded, handleExpand, handleCollapse } = this.props;
    return expanded ?
      handleCollapse() :
      handleExpand();
  }

  render() {
    return (
      <TextButton handleClick={this.handleClick} className="cp-new-search-button">
        {this.props.expanded ? renderExpanded() : renderCollapsed()}
      </TextButton>
    );
  }
}

NewSearchButton.propTypes = {
  expanded: PropTypes.bool,
  handleExpand: PropTypes.func,
  handleCollapse: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/search/NewSearchButton/NewSearchButton.jsx